import { DropResult } from 'react-beautiful-dnd';

export const reorder = (items: any[], result: DropResult) => {
  if (!result.destination) return items;

  const sourceIndex = result.source.index;
  const destinationIndex = result.destination.index;
  const itemsWithoutStart = [...items.slice(0, sourceIndex), ...items.slice(sourceIndex + 1)];
  const updatedItems = [
    ...itemsWithoutStart.slice(0, destinationIndex),
    items[sourceIndex],
    ...itemsWithoutStart.slice(destinationIndex)
  ];

  return updatedItems;
};

export const reorderSections = (sections: any[], result: DropResult) => {
  if (!result.destination) return sections;

  const sourceIndex = result.source.index;
  const destinationIndex = result.destination.index;
  const sectionsWithoutStart = [...sections.slice(0, sourceIndex), ...sections.slice(sourceIndex + 1)];
  const updatedSections = [
    ...sectionsWithoutStart.slice(0, destinationIndex),
    sections[sourceIndex],
    ...sectionsWithoutStart.slice(destinationIndex)
  ];

  return updatedSections;
};
